$(function () {

  // Show element depending on checkbox
  $('[data-show-by-checkbox]').each(function () {
    let $area = $(this);
    let $checkbox = $($(this).data('show-by-checkbox'));

    let activate = function () {
      let checked = $(this).is(':checked');
      $area.toggleClass('d-none', !checked)
      $area.children().find(':input').attr('disabled', !checked);
    };

    $checkbox.change(activate);
    $checkbox.trigger('change');
  });

  // Hide element depending on checkbox
  $('[data-hide-by-checkbox]').each(function () {
    let $area = $(this);
    let $checkbox = $($(this).data('hide-by-checkbox'));

    let activate = function () {
      let checked = $(this).is(':checked');
      $area.toggleClass('d-none', checked)
    };

    $checkbox.change(activate);
    $checkbox.trigger('change');
  });

  // Hide element depending on selected option
  $('[data-hide-by-select]').each(function () {
    var $area = $(this);
    var $select = $($(this).data('hide-by-select'));
    var show_value = $(this).data('show-value');

    var activate = function () {
      var selected = $(this).val() == show_value;
      $area.toggleClass('d-none', !selected)
    };

    $select.change(activate);
    $select.trigger('change');
  })
});
